module.exports = __webpack_public_path__ + "static/media/Cadila-Logo-ru.e3b5d18d.svg";